import styled from "@emotion/styled";

import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { height: number, width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

const Path = styled.path<{ isOpen?: boolean }>(({ isOpen }) => ({
  transition: 'opacity 0.2s, transform 0.2s',
  opacity: isOpen ? 0 : 1,
  transform: isOpen ? 'rotate(90deg)' : 'rotate(0)',
  transformOrigin: 'center',
}))

const MinusPath = styled.path<{ isOpen?: boolean }>(({ isOpen }) => ({
  transition: 'opacity 0.2s',
  opacity: isOpen ? 1 : 0,
}))

export type PlusMinusIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
  color?: string,
  isOpen?: boolean,
}>;

export const PlusMinusIcon: React.FC<PlusMinusIconProps> = ({ width = 16, height = 16, color = colors.primary, isOpen, ...props }) => (
  <IconSpan {...props} height={height} width={width}>
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Path isOpen={isOpen} d="M7.30907 8.69167H3.86523V7.30834H7.30907V3.8645H8.6924V7.30834H12.1362V8.69167H8.6924V12.1355H7.30907V8.69167Z" fill={color} />
      <MinusPath isOpen={isOpen} d="M3.73047 8.69168V7.30835H12.2681V8.69168H3.73047Z" fill={color} />
    </svg>
  </IconSpan>
);